import { render, staticRenderFns } from "./CommunityQna.vue?vue&type=template&id=b0b7f684&scoped=true"
import script from "./CommunityQna.vue?vue&type=script&lang=js"
export * from "./CommunityQna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b7f684",
  null
  
)

export default component.exports